/* gk-funnel.js
 *
 * Menyegarkan empat angka corong penyaringan di beranda dari count.json,
 * file yang sama yang dipakai gk-job-count.js. Sejak 2026-08-03 file itu
 * membawa objek `corong`:
 *
 *   { "count": 542, "corong": { "disaring": 4275, "jalur_visa": 3810,
 *                               "lolos": 1044, "tampil": 542 } }
 *
 * 🔴 Kunci kedua dulu bernama `perusahaan` dan diganti 2026-08-17. Isinya
 * jumlah PERUSAHAAN berbeda, sementara tiga kunci tetangganya menghitung
 * LOWONGAN, jadi tahap kedua tidak pernah bisa terlihat menurun di corong yang
 * memajang keempatnya berjajar. Kalau suatu saat ada yang mau menambah tahap
 * baru: pastikan satuannya lowongan, atau corongnya akan patah lagi dengan
 * cara yang persis sama.
 *
 * Kenapa perlu: angka corong di file desain adalah karangan (42.000 / 9.100 /
 * 3.400 / 1.280), sepuluh kali lipat kenyataan, dan tahap terakhirnya
 * bertabrakan dengan jumlah lowongan yang benar-benar tayang. Angka yang bisa
 * dibantah pengunjung dengan membuka satu halaman tidak boleh ditulis tangan.
 *
 * Angka statis di Liquid TIDAK dihapus. Dia tetap terkirim di HTML, jadi
 * crawler dan pengunjung tanpa JS tetap melihat angka yang masuk akal.
 * Skrip ini cuma menimpanya kalau berhasil.
 */
(function () {
  'use strict';

  // Sejak 2026-08-15 skrip ini disisipkan DUA section: gk-funnel (beranda) dan
  // gk-about-diff (Tentang Kami). Halaman yang memuat dua-duanya akan
  // menjalankannya dua kali, dan itu berarti dua kali menembak count.json
  // untuk hasil yang sama. Penjaga ini menghentikannya di panggilan kedua.
  if (window.__gkFunnelSudahJalan) return;
  window.__gkFunnelSudahJalan = true;

  var URL_COUNT =
    'https://sftrxlriosixrryqcibx.supabase.co/storage/v1/object/public/job-feed/count.json';

  var target = document.querySelectorAll('[data-gk-funnel-key]');
  if (!target.length || typeof fetch !== 'function') return;

  // Format ribuan id-ID: 2.608. Sama persis dengan gk-job-count.js; sengaja
  // disalin, bukan di-share lewat file ketiga, karena dua skrip ini dimuat
  // terpisah dan satu file lagi cuma untuk enam baris tidak sepadan.
  function format(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  fetch(URL_COUNT, { cache: 'no-store' })
    .then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function (data) {
      var corong = data && data.corong;
      if (!corong || typeof corong !== 'object') return;

      // ss19 (17 Sep 2026): puncak dihitung dari angka yang BENAR-BENAR
      // dipakai section ini, bukan dari corong.disaring, supaya batangnya
      // tetap benar kalau suatu saat langkah pertama dicabut.
      var puncak = 0;
      for (var p = 0; p < target.length; p++) {
        var np = corong[target[p].getAttribute('data-gk-funnel-key')];
        if (typeof np === 'number' && isFinite(np) && np > puncak) puncak = np;
      }

      for (var i = 0; i < target.length; i++) {
        var el = target[i];
        var n = corong[el.getAttribute('data-gk-funnel-key')];

        // Nol atau negatif hampir pasti hitungan yang gagal separuh jalan.
        // Lebih baik membiarkan angka statis daripada memajang corong berisi
        // nol, yang terbaca seolah tidak ada lowongan sama sekali.
        if (typeof n !== 'number' || !isFinite(n) || n <= 0) continue;

        el.textContent = format(n);

        // Lebar batang ss19, ditulis di .gk-funnel__step (pemilik --gk-bar di
        // Liquid) supaya angka statis dan angka hidup memakai satu variabel.
        var langkah = el.closest ? el.closest('.gk-funnel__step') : null;
        if (langkah && puncak > 0) {
          langkah.style.setProperty('--gk-bar', Math.round((n / puncak) * 100) + '%');
        }
      }
    })
    .catch(function () {
      // Sengaja diam, sama alasannya dengan gk-job-count.js: kegagalan
      // menyegarkan angka hiasan tidak boleh memunculkan error di console
      // halaman yang lain-lainnya sehat.
    });
})();
